import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';

import { emtContentDataModel } from '../dataModels';
import { getPageType } from './getPageType';

const PlpCategoryIntroduction = ({ nValue: propNvalue }) => {
  const { channel, path, customContext } = useContext(ExperienceContext);

  const nValue = propNvalue || customContext?.variables?.navParam;
  const finalNValue = nValue?.indexOf('N-') < 0 ? `N-${nValue}` : nValue;
  const isMobile = channel === 'mobile';
  const isBrowsePage = getPageType(path) === 'browse';

  const { data, loading, error } = useDataModel('emtContent', {
    variables: {
      contentId: finalNValue,
      pageName: 'plp'
    },
    skip: !finalNValue || !isBrowsePage
  });

  const categoryIntroduction = data?.emtContent?.content?.categoryIntroduction?.description || '';

  if (error || loading || !data || !categoryIntroduction) return null;

  return (
    <div data-component="PlpCategoryIntroduction">
      <Typography
        color="subtle"
        variant={isMobile ? 'body-sm' : 'body-base'}
      >
        {categoryIntroduction}
      </Typography>
    </div>
  );
};

PlpCategoryIntroduction.propTypes = {
  nValue: PropTypes.string.isRequired
};

PlpCategoryIntroduction.displayName = 'PlpCategoryIntroduction';

PlpCategoryIntroduction.dataModel = emtContentDataModel;

export { PlpCategoryIntroduction };
